import {InputValidator} from "../InputValidationHandler";
import FormValidations from "../FormValidations";

export class DefaultPhoneValidator implements InputValidator {
    private readonly isMandatory: boolean;

    constructor(isMandatory: boolean) {
        this.isMandatory = isMandatory;
    }

    isValid(element: HTMLInputElement) {
        if (this.isMandatory) {
            return this.isValidMandatoryPhone(element);
        }
        return this.isValidPhone(element);
    }

    private isValidPhone(element: HTMLInputElement) {
        return FormValidations.isValidPhone(element.value);
    }

    private isValidMandatoryPhone(element: HTMLInputElement) {
        return FormValidations.isValidMandatoryPhone(element.value);
    }
}